import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { Observable } from "rxjs";
import { urls } from "../../../common/model/properties";
import { SecureStorageService } from "../../../secure-storage.service";
import { DatePipe } from "@angular/common";

@Injectable()
export class PqvDashboardService {
    public memberDetails = signal(null)
    constructor(
        private http: HttpClient,
        private secureStorage: SecureStorageService,
        private datePipe: DatePipe
    ) { }

    setMemberDetails(memberDetails: any) {
        this.memberDetails.set(memberDetails)

    }

    getLAbDetailsData(memberID: any): Observable<any> {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        let url = urls.getLabDetails;
        const todaysDate = new Date();
        const toDate = this.datePipe.transform(todaysDate, 'yyyy-MM-dd HH:mm:ss.SSS');
        const fiveYearsAgoDate = new Date();
        fiveYearsAgoDate.setFullYear(fiveYearsAgoDate.getFullYear() - 5);
        const fromDate = this.datePipe.transform(fiveYearsAgoDate, 'yyyy-MM-dd HH:mm:ss.SSS');
        let payload = {
            memberId: memberID,
            fromDate: fromDate,
            toDate: toDate
        };

        return this.http.post(url, payload, { headers });
    }

    getMedicationDetails(memberID: any): Observable<any> {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        let url = urls.getMedicationDetails;
        const todaysDate = new Date();
        const toDate = this.datePipe.transform(todaysDate, 'yyyy-MM-dd HH:mm:ss.SSS');
        const fiveYearsAgoDate = new Date();
        fiveYearsAgoDate.setFullYear(fiveYearsAgoDate.getFullYear() - 5);
        const fromDate = this.datePipe.transform(fiveYearsAgoDate, 'yyyy-MM-dd HH:mm:ss.SSS');
        let payload = {
            memberId: memberID,
            fromDate: fromDate,
            toDate: toDate
        };
        return this.http.post(url, payload, { headers });
    }
    getListOfFileNetDocuments(kvpl, documentCode, ) {
        const ppjwt = JSON.parse(
          this.secureStorage.getSecureInfoInLocalStorage('currentUser')
        );
        const headers = new HttpHeaders({
          Authorization: 'Bearer ' + ppjwt.access_token,
        });
        let payload = {
          documentCode: documentCode,
          keyValuePairList: JSON.stringify(kvpl),
        };
        const myParams = new HttpParams()
          .set('documentCode', documentCode)
          .set('keyValuePairList', JSON.stringify(kvpl));
        const options = { headers: headers };
        return this.http.post(urls.getEdsListDocuments, payload, options);
      }

            getListOfEncounters(memid,startDate,endDate){
        const ppjwt = JSON.parse(
          this.secureStorage.getSecureInfoInLocalStorage('currentUser')
        );
        const headers = new HttpHeaders({
          Authorization: 'Bearer ' + ppjwt.access_token,
        });
        let payload = {
          "memberId": memid,
          "startDate": startDate,
          "endDate": endDate
        }
        const options = { headers: headers };
        return this.http.post(urls.getAthenaEncounters, payload, options);
      }
      getEncounterDocument(encounterID){
        const ppjwt = JSON.parse(
          this.secureStorage.getSecureInfoInLocalStorage('currentUser')
        );
        const headers = new HttpHeaders({
          Authorization: 'Bearer ' + ppjwt.access_token,
          
          
        });
        let payload = {
          "encounterId": encounterID
        }
        const options = { headers: headers };
        return this.http.post(urls.getAthenaDoc, payload, { responseType: 'blob' , headers: headers  });
      }
      formatDate(today){
        
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();

        const formattedDate = `${mm}/${dd}/${yyyy}`;
        return formattedDate;
      }
}